/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  contain: content;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  height: 2rem;
}

:host(:focus-visible) {
  outline: none;
}
:host(:focus-visible) .container {
  background-color: var(--davinci-color-primary-dark,#005B8E) !important;
}

.container {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  height: 2rem;
  width: 3.4285714286rem;
  border-radius: 1rem;
}
.container.hasIcon {
  width: 5.1428571429rem;
}

.knob {
  display: block;
  position: absolute;
  top: 0.2142857143rem;
  height: 1.5714285714rem;
  width: 1.5714285714rem;
  border-radius: 50%;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-text-on-secondary, #FFFFFF);
}

.iconContainer {
  position: absolute;
  opacity: 1;
}
.iconContainer .icon {
  width: 1.5714285714rem;
  height: 1.5714285714rem;
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary, #FFFFFF);
}
.iconContainer.grey > .icon {
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFFFFF);
}
.iconContainer.darkgrey > .icon {
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary-dark, #FFFFFF);
}

.container,
.knob,
.iconContainer {
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
}

:host(:not([checked])) .container {
  background-color: #50585C;
  background-color: var(--davinci-color-secondary-dark, #50585C);
}
:host(:not([checked])) .container:hover {
  background-color: #737F85;
  background-color: var(--davinci-color-secondary, #737F85);
}
:host(:not([checked])) .knob {
  left: 0.2142857143rem;
}
:host(:not([checked])) .iconContainer {
  left: 2.5rem;
}
:host(:not([checked])) .iconOn {
  opacity: 0;
}

:host([checked]) .container {
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
}
:host([checked]) .container:hover {
  background-color: #009DF4;
  background-color: var(--davinci-color-primary-light, #009DF4);
}
:host([checked]) .container .knob {
  left: 1.6428571429rem;
}
:host([checked]) .container.hasIcon .knob {
  left: 3.3571428571rem;
}
:host([checked]) .container .iconContainer {
  left: -2.5rem;
}
:host([checked]) .container .iconOff {
  opacity: 0;
}

:host([disabled]) {
  pointer-events: none;
  cursor: default;
}
:host([disabled]) .container {
  background-color: #B1B8BC;
  background-color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .icon {
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}

:host([hidden]) {
  display: none;
}`;
export { style };
